import { BrowserModule } from '@angular/platform-browser';
import {Http, HttpModule} from '@angular/http';
import { NgModule, ErrorHandler } from '@angular/core';

import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CloudSettings, CloudModule } from '@ionic/cloud-angular';
import { VoltioPlatformApp } from './app.component';
import { AboutPage } from '../pages/about/about';
import { PopoverPage } from '../pages/about-popover/about-popover';
import { LoginPage } from '../pages/login/login';
import { MapPage } from '../pages/map/map';
import { SchedulePage } from '../pages/schedule/schedule';
import { ScheduleFilterPage } from '../pages/schedule-filter/schedule-filter';
import { SessionDetailPage } from '../pages/session-detail/session-detail';
import { SignupPage } from '../pages/signup/signup';
import { SpeakerDetailPage } from '../pages/speaker-detail/speaker-detail';
import { SpeakerListPage } from '../pages/speaker-list/speaker-list';
import { TabsPage } from '../pages/tabs/tabs';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { SupportPage } from '../pages/support/support';

import { EnergyUsage } from '../pages/energy-usage/energy-usage';

import { ConferenceData } from '../providers/conference-data';
import { UserData } from '../providers/user-data';
import { SolarAnalyticsData } from '../providers/solar-analytics-data';
import { LoggerService} from '../providers/logger-service';
import { Logger } from 'angular2-logger/core';

import {IonicStorageModule, Storage} from '@ionic/storage';


import {AngularFireModule} from 'angularfire2';

import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import {MeterData} from '../providers/meter-data';
import {KeysPipe} from '../pipes/KeysPipe';
import {NgObjectPipesModule} from 'ngx-pipes';

import { ChartModule } from 'angular-highcharts';
import {EnergySummaryChart} from '../pages/energy-summary-chart/energy-summary-chart';
import { AuthConfig, AuthHttp } from 'angular2-jwt';
import {AuthService} from "../providers/auth-service";
import { UserProfileProvider } from '../providers/user-profile/user-profile';

import {UserProfilePage} from '../pages/user-profile/user-profile';

let storage =  new Storage({ name: '__myVdb' });

export function getAuthHttp(http) {
  return new AuthHttp(new AuthConfig({
    globalHeaders: [{'Accept': 'application/json'}],
    tokenGetter: (() => storage.get('id_token'))
  }), http);
}

// initialise cloud settings
const cloudSettings: CloudSettings = {
  'core': {
    'app_id': '8fe4f576'
  }
};

// Initialize Firebase
export const firebaseConfig = {
  apiKey: "AIzaSyAclrOIgctjN4TTqCuRwOzYMKEEBKiLeu8",
  authDomain: "staging-voltio.firebaseapp.com",
  databaseURL: "https://staging-voltio.firebaseio.com",
  projectId: "staging-voltio",
  storageBucket: "staging-voltio.appspot.com",
  messagingSenderId: "564008437740"
};

@NgModule({
  declarations: [
    VoltioPlatformApp,
    AboutPage,
    UserProfilePage,
    LoginPage,
    MapPage,
    PopoverPage,
    SchedulePage,
    ScheduleFilterPage,
    SessionDetailPage,
    SignupPage,
    SpeakerDetailPage,
    SpeakerListPage,
    TabsPage,
    TutorialPage,
    SupportPage,
    EnergyUsage,
    EnergySummaryChart,
    KeysPipe
  ],
  imports: [
    IonicStorageModule,
    ChartModule,
    BrowserModule,
    HttpModule,
    NgObjectPipesModule,
    IonicModule.forRoot(VoltioPlatformApp, {}, {
      links: [
        { component: TabsPage, name: 'Tabs', segment: 'tabs' },
        { component: SchedulePage, name: 'Upcoming Events', segment: 'schedule' },
        { component: SessionDetailPage, name: 'SessionDetail', segment: 'sessionDetail/:name' },
        { component: ScheduleFilterPage, name: 'ScheduleFilter', segment: 'scheduleFilter' },
        { component: SpeakerListPage, name: 'SpeakerList', segment: 'speakerList' },
        { component: SpeakerDetailPage, name: 'SpeakerDetail', segment: 'speakerDetail/:name' },
        { component: MapPage, name: 'Map', segment: 'map' },
        { component: AboutPage, name: 'About', segment: 'about' },
        { component: TutorialPage, name: 'How it works', segment: 'Help' },
        { component: SupportPage, name: 'SupportPage', segment: 'support' },
        { component: LoginPage, name: 'LoginPage', segment: 'login' },
        { component: UserProfilePage, name: 'UserProfilePage', segment: 'user-profile' },
        { component: SignupPage, name: 'SignupPage', segment: 'signup' },
        { component: EnergySummaryChart, name: 'EnergyUsageChart', segment: 'usage' },
        { component: EnergyUsage, name: 'EnergyUsageTable', segment: 'usage' }
      ]
    }),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    CloudModule.forRoot(cloudSettings)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    VoltioPlatformApp,
    AboutPage,
    UserProfilePage,
    LoginPage,
    MapPage,
    PopoverPage,
    SchedulePage,
    ScheduleFilterPage,
    SessionDetailPage,
    SignupPage,
    SpeakerDetailPage,
    SpeakerListPage,
    TabsPage,
    TutorialPage,
    SupportPage,
    EnergySummaryChart,
    EnergyUsage
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    {
      provide: AuthHttp,
      useFactory: getAuthHttp,
      deps: [Http]
    },
    ConferenceData,
    UserData,
    MeterData,
    SolarAnalyticsData,
    AuthService,
    InAppBrowser,
    LoggerService,
    Logger,
    SplashScreen,
    UserProfileProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts